// extracted by css-extract-rspack-plugin
export default {"field":"FormField__field--AB_zV","label":"FormField__label--_dpV0","note":"FormField__note--AbGeB"};